import React from 'react';
import { ChairInfo, Info, TableFriendlyName } from '../../store/info/types';
import { Submission } from '../../store/submission/types';
import MyGridRedux from '../../components/MyGridRedux/MyGridRedux';
import { AppState } from '../../store/state';
import { selectInfo, selectKeywordState, selectSubmissionState } from '../../store/selectors';
import { AppDispatch } from '../../store/store';
import { connect } from 'react-redux';
import Loading from '../../components/Loading/Loading';
import { getSubmissionRow } from '../../helpers/table';
import { useTranslation } from 'react-i18next';
import useFetchTableData from '../../store/table/useFetchTableData';

interface Props {
  loading: boolean;
  submissionsById: { [key: string]: Submission };
  keywordById: { [key: number]: Keyword };
  info: Info;
}

const SubmissionsBidsPage: React.FC<Props> = ({ loading, submissionsById, keywordById, info }) => {
  const { t, i18n } = useTranslation();
  const friendlyName: TableFriendlyName = 'submissions_bids';
  const [fetchData, fetchCustomColumnsData] = useFetchTableData(friendlyName);

  const chairInfo = info as ChairInfo;

  /* Build input data */
  const inputData: unknown[] = [];
  Object.values(submissionsById).forEach((submission, index) => {
    // Add bidding info
    const submissionBid = chairInfo.submissions_bids.byId[submission.id] ?? {
      id: submission.id,
      positive: 0,
      negative: 0,
      bids: 0,
    };
    const newRegister = { ...getSubmissionRow(submission, true, keywordById, t), ...submissionBid };

    inputData.push(newRegister);
  });

  return (
    <>
      <div className="h-full">
        {loading ? (
          <Loading />
        ) : (
          <MyGridRedux
            friendlyName={friendlyName}
            inputData={inputData as Record<string, unknown>[]}
            getInfoAction={fetchData}
            getCustomColumnsData={fetchCustomColumnsData}
          />
        )}
      </div>
    </>
  );
};

const mapStateToProps = (state: AppState) => ({
  loading: selectSubmissionState(state).loading || selectInfo(state).loading,
  submissionsById: selectSubmissionState(state).submissionsById,
  keywordById: selectKeywordState(state).keywordById,
  info: state.info.info,
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(SubmissionsBidsPage);
